module.exports = __webpack_public_path__ + "img/EmptyState.b9c3af41.png";